module.exports = __webpack_public_path__ + "img/img40.616ff583.jpg";